import { render } from "./Eliminaciones.vue?vue&type=template&id=a6f0eddc&scoped=true"
import script from "./Eliminaciones.vue?vue&type=script&lang=js"
export * from "./Eliminaciones.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./Eliminaciones.vue?vue&type=style&index=1&id=a6f0eddc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6f0eddc"]])

export default __exports__